import { escapeHtml, fmtInt, housePill, memberUrl } from "../format.js";

/** Parliamentarian card (Figma "ID Visual"): tags (house, UF, party), italic name, round photo, vote count. */
export function renderMemberCard(m) {
  return `
    <li class="member-card">
      <a class="member-card__link" href="${memberUrl(m)}" data-link>
        <div class="member-card__meta">
          ${housePill(m.house)}
          ${m.uf ? `<span class="pill pill--senado">${escapeHtml(m.uf)}</span>` : ""}
          ${m.party_sigla ? `<span class="pill pill--sage">${escapeHtml(m.party_sigla)}</span>` : ""}
          ${m.in_exercise === false ? `<span class="pill pill--neutral">afastado</span>` : ""}
        </div>
        <div class="member-card__name" title="${escapeHtml(m.name)}">${escapeHtml(m.name)}</div>
        ${m.photo_url ? `<img class="avatar avatar--lg" src="${escapeHtml(m.photo_url)}" alt="" loading="lazy" />` : `<span class="avatar avatar--lg avatar--empty"></span>`}
        <div class="member-card__votes">${fmtInt(m.votes_n ?? 0)} ${m.votes_n === 1 ? "voto" : "votos"}</div>
      </a>
    </li>`;
}
